module.exports = __webpack_public_path__ + "static/tutorial-slide-3-5fbd4a656fae79353ea56d42d07bda5c.png";